/* POYOPOP manga theme v3: AJAX cart + drawer. No dependencies. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var el = document.getElementById('MangaCartDrawer');
  if (!el) return;
  var enabled = el.dataset.enabled === 'true';
  var threshold = parseInt(el.dataset.threshold || '0', 10);
  var currency = el.dataset.currency || 'USD';
  var lastAddedProductId = null;
  var $ = function (s) { return el.querySelector(s); };

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Mirrors snippets/title-parts.liquid: drop 'BEST SELLER | ' style prefixes and [TAGS].
  function cleanTitle(t) { t = String(t || '').replace(/\[(PRE-ORDER|SOLD OUT)\]/g, ''); var i = t.lastIndexOf(' | '); return (i > -1 ? t.slice(i + 3) : t).trim(); }
  function sized(url, w) { if (/^(data|blob):/.test(url)) return url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw b; return b; }); });
  }

  function syncCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (n) {
      var changed = String(n.textContent) !== String(count);
      n.textContent = count;
      if (changed) { n.classList.remove('is-bump'); void n.offsetWidth; n.classList.add('is-bump'); }
    });
    $('[data-mcd-count]').textContent = count;
  }

  function renderShip(total) {
    var box = $('[data-mcd-ship]');
    if (!threshold) { box.hidden = true; return; }
    box.hidden = false;
    var left = threshold - total;
    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
    $('[data-mcd-bar]').style.width = pct + '%';
    $('[data-mcd-ship-msg]').innerHTML = left > 0
      ? 'You’re ' + money(left) + ' away from free shipping <span>(' + esc(el.dataset.region) + ')</span>'
      : 'Free shipping unlocked <span>(' + esc(el.dataset.region) + ')</span>';
    box.classList.toggle('is-done', left <= 0);
  }

  function lineHTML(item, idx) {
    var props = '';
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        if (k.charAt(0) !== '_' && item.properties[k]) props += '<div class="mcd__prop">' + esc(k) + ': ' + esc(item.properties[k]) + '</div>';
      });
    }
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="mcd__var">' + esc(item.variant_title) + '</div>' : '';
    var was = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
    return '<div class="mcd__line">' +
      (item.image ? '<img src="' + esc(sized(item.image, 200)) + '" alt="" width="76" height="76" loading="lazy">' : '<div class="mcd__ph"></div>') +
      '<div class="mcd__info"><a href="' + esc(item.url) + '" class="mcd__title">' + esc(cleanTitle(item.product_title)) + '</a>' + variant + props +
      '<div class="mcd__qty" role="group" aria-label="Quantity">' +
      '<button type="button" data-line="' + (idx + 1) + '" data-q="' + (item.quantity - 1) + '" aria-label="Remove one">−</button>' +
      '<span>' + item.quantity + '</span>' +
      '<button type="button" data-line="' + (idx + 1) + '" data-q="' + (item.quantity + 1) + '" aria-label="Add one">+</button></div></div>' +
      '<div class="mcd__price">' + was + money(item.final_line_price) + '</div></div>';
  }

  function render(cart) {
    syncCounts(cart.item_count);
    renderShip(cart.total_price);
    var body = $('[data-mcd-body]');
    var foot = $('[data-mcd-foot]');
    if (!cart.item_count) {
      body.innerHTML = '<div class="mcd__empty"><p>Your bag is empty.</p><a class="btn" href="' + root + 'collections/everything?sort_by=best-selling">Shop best sellers</a></div>';
      foot.hidden = true;
      $('[data-mcd-upsell]').hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(lineHTML).join('');
    foot.hidden = false;
    $('[data-mcd-total]').textContent = money(cart.total_price);
    var hasPre = cart.items.some(function (i) { return i.properties && i.properties.Ships && /pre-order/i.test(i.properties.Ships); });
    var hasNow = cart.items.some(function (i) { return !(i.properties && i.properties.Ships && /pre-order/i.test(i.properties.Ships)); });
    $('[data-mcd-mixed]').hidden = !(hasPre && hasNow);
    renderUpsell(cart);
  }

  function renderUpsell(cart) {
    var box = $('[data-mcd-upsell]');
    if (el.dataset.upsell !== 'true') { box.hidden = true; return; }
    var anchor = lastAddedProductId || cart.items[0].product_id;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var url = root + 'recommendations/products.json?product_id=' + anchor + '&limit=6&intent=related';
    json(url).then(function (r) {
      var picks = (r.products || []).filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; }).slice(0, 2);
      if (!picks.length) { box.hidden = true; return; }
      box.hidden = false;
      $('[data-mcd-ups]').innerHTML = picks.map(function (p) {
        var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
        var single = p.variants.length === 1;
        return '<div class="mcd__up">' +
          (p.featured_image ? '<img src="' + esc(sized(p.featured_image, 160)) + '" alt="" width="58" height="58" loading="lazy">' : '') +
          '<div class="mcd__upinfo"><a href="' + esc(p.url) + '">' + esc(cleanTitle(p.title)) + '</a><span>' + money(v.price) + '</span></div>' +
          (single
            ? '<button type="button" class="btn btn--s" data-quick="' + v.id + '">Add</button>'
            : '<a class="btn btn--line btn--s" href="' + esc(p.url) + '">Choose size</a>') +
          '</div>';
      }).join('');
    }).catch(function () { box.hidden = true; });
  }

  function refresh() { return json(root + 'cart.js').then(function (c) { render(c); return c; }); }

  function open() {
    if (!enabled) { window.location.href = root + 'cart'; return; }
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mcd-lock');
    refresh();
    setTimeout(function () { var p = el.querySelector('.mcd__panel'); if (p) { p.setAttribute('tabindex', '-1'); p.focus({ preventScroll: true }); } }, 50);
  }
  function close() {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mcd-lock');
  }

  function add(items, productId) {
    lastAddedProductId = productId || null;
    return json(root + 'cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) })
      .then(function () {
        if (window.MangaTrack) window.MangaTrack('add_to_cart', { product_id: productId });
        if (enabled) open(); else window.location.href = root + 'cart';
      });
  }

  el.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mcd-close]')) { close(); return; }
    var q = t.closest('[data-line]');
    if (q) {
      q.disabled = true;
      json(root + 'cart/change.js', { method: 'POST', body: JSON.stringify({ line: +q.dataset.line, quantity: Math.max(0, +q.dataset.q) }) })
        .then(render).catch(refresh);
      return;
    }
    var quick = t.closest('[data-quick]');
    if (quick) {
      quick.disabled = true; quick.textContent = 'Adding…';
      add([{ id: +quick.dataset.quick, quantity: 1 }]).catch(function () { quick.textContent = 'Sold out'; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });

  // Any link to /cart opens the drawer instead (header count, sticky nav).
  if (enabled) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || a.closest('#MangaCartDrawer')) return;
      var path = a.getAttribute('href').split('?')[0].replace(/\/$/, '');
      if (path === root.replace(/\/$/, '') + '/cart' || path === '/cart') { e.preventDefault(); open(); }
    });
  }

  window.MangaCart = { open: open, close: close, add: add, refresh: refresh };
})();
